"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var messages_1 = require("./messages");
var BooleanType = {
    type: function (errorMsg) {
        return function (target) {
            if (typeof target === 'boolean') {
                return false;
            }
            return { message: errorMsg } || { message: messages_1.default.boolean };
        };
    }
};
exports.default = BooleanType;



//////////////////
// WEBPACK FOOTER
// ../node_modules/kya/dist/type/boolean/index.js
// module id = 321
// module chunks = 0